import { Button } from "antd";
import React, { useState } from "react";
import vCardFunctions from "../redux/services/vCard.services";
import addAppleWalletImg from "../../src/assets/images/apple-wallet-icon.png";

const AddAppleWalletButton = ({
  vCard = { _id: null },
  secondaryColor,
  backgroundColor,
}) => {
  const { _id } = vCard;
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const onHandleClick = async () => {
    if (!_id) return;
    setErrorMessage("");
    setLoading(true);
    try {
      const response = await vCardFunctions.getQrPassbook(_id);

      if (response.data && response.data.data) {
        const { data } = response.data;
        const { url, fileName } = data;

        const element = document.createElement("a");
        element.href = url;
        element.download = fileName + ".pkpass";
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
      }
    } catch (error) {
      if (error?.response?.data) {
        const errorResponse = error.response.data;
        setErrorMessage(errorResponse.data);
      }
    }
  };

  return (
    <>
      <Button
        shape="round"
        size="middle"
        style={{
          height: "2.5rem",
          borderColor: secondaryColor,
          color: secondaryColor,
          backgroundColor,
          borderWidth: 0,
          boxShadow: "3px 3px 3px 3px #88888a3a",
          margin: "0.5rem",
          minWidth: !vCard.leadEnable ? "20rem" : 0,
        }}
        loading={loading}
        onClick={(e) => onHandleClick(e).finally(() => setLoading(false))}
        icon={
          <img
            src={addAppleWalletImg}
            alt="Add to Apple Wallet"
            style={{
              height: "1.5rem",
              width: "2rem",
              marginRight: "0.5rem",
            }}
          ></img>
        }
      >
        Add to Apple Wallet
      </Button>
      {errorMessage && (
        <p style={{ color: "red", marginLeft: "0.5rem" }}>{errorMessage}</p>
      )}
    </>
  );
};

export default AddAppleWalletButton;
